import { useEffect, useState } from "react";

/**
 * Minimales Hash-Routing (`#/apotheken/123`). Token für Einladung/Reset stehen im Fragment:
 * Sie gelangen so weder in Server-Logs noch in Referrer.
 */
const read = () =>
  location.hash
    .replace(/^#\/?/, "")
    .split("/")
    .filter(Boolean)
    .map((p) => decodeURIComponent(p));

export function useHashRoute(): [string[], (path: string) => void] {
  const [parts, setParts] = useState(read);
  useEffect(() => {
    const on = () => setParts(read());
    window.addEventListener("hashchange", on);
    return () => window.removeEventListener("hashchange", on);
  }, []);
  return [parts, navigate];
}

export function navigate(path: string) {
  const target = `#/${path.replace(/^\//, "")}`;
  if (location.hash !== target) location.hash = target;
}

/** Entfernt Token aus der Adresszeile, sobald sie gelesen wurden. */
export function clearHash() {
  history.replaceState(null, "", location.pathname + location.search);
  window.dispatchEvent(new HashChangeEvent("hashchange"));
}
